<div class="registration-layout login-banner">
  <img alt="imagedetails" src="assets/images/logos/LogoWhite.png" class="logo" />
  <div class="registration-container">
    <router-outlet></router-outlet>
  </div>
</div>
